export const someTrue = x => x.some(Boolean);
